import { Avatar, Box, ListItem, ListItemAvatar, ListItemText, Typography } from "@material-ui/core";
import Description from "@material-ui/icons/Description";
import LockIcon from "@material-ui/icons/Lock";
import Loader from "legacy-components/loader";
import { useIdentityApplicationInfo } from "libs/resources/identity/applications/application-views/IdentityApplicationInfo";
import ApplicationService from "libs/resources/identity/applications/ApplicationService";
import { ErrorMessage } from "modus/components/error-message/ErrorMessage";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";


interface ScopeData {
    name: string;
    consentMessage: string;
    developerDocumentation?: string;
    description?: string;
}
interface ScopeListProps {
    applicationList: any[];
}

export const ScopeList: React.FC<ScopeListProps> = ( {  applicationList} ) => {


    const identityEnvironment = useSelector((state: any) => state?.common?.identityEnvironment ?? "trimble-pre-prod");


    return (
        <Box>
      <Typography variant="h6" gutterBottom style={{ fontSize: "16px", fontWeight: 500 }}>
        Scopes
      </Typography>
      <Box mt={2} />
      {applicationList && applicationList.map((application, appIndex) => (
        <React.Fragment key={appIndex}>
          {application.scopes && application.scopes.length > 0 ? (
            application.scopes.map((scope: ScopeData, index: string) => (
              <ListItem key={`${appIndex}-${index}`} style={{ borderBottom: `1px solid #D9D9D9`, borderTop: `1px solid #D9D9D9` }}>
                <ListItemAvatar>
                  <Avatar style={{ backgroundColor: '#D9D9D9' }}>
                    <LockIcon style={{ color: "#000" }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box style={{ fontSize: "16px", fontWeight: 500 }}>
                      {application.name}:{scope.name}
                    </Box>
                  }
                  secondary={
                    <Box style={{ fontSize: "14px", fontWeight: 300, color: "#000" }}>
                      {scope.developerDocumentation ?? scope.description}
                    </Box>
                  }
                />
              </ListItem>
            ))
          ) : (
            <ListItem key={`${appIndex}-no-scope`} style={{ borderBottom: `1px solid #D9D9D9`, borderTop: `1px solid #D9D9D9` }}>
              <ListItemAvatar>
                <Avatar style={{ backgroundColor: '#D9D9D9' }}>
                  <LockIcon style={{ color: "#000" }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box style={{ fontSize: "16px", fontWeight: 500 }}>
                    {application.name}
                  </Box>
                }
              />
            </ListItem>
          )}
        </React.Fragment>
      ))}
    </Box>
    )
}